export default "__VITE_ASSET__rl4x0om8__"